// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./utils/font/KaLaTeXa_ Font/KaLaTeXaTEXT_Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./utils/font/KaLaTeXa_ Font/KaLaTeXaTEXT_Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+Thai:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* import font from file */
@font-face {
    font-family: 'KaLaTeXa';
    font-style: normal;
    font-weight: 100;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
        format('truetype');
}

@font-face {
    font-family: 'KaLaTeXa';
    font-style: bold;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
        format('truetype');
}

body {
    margin: 0;
    /* font-family: 'Noto Sans Thai', sans-serif !important; */
    font-family: 'KaLaTeXa', sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
}

.filled-hover-button {
    transition: 0.3s;
    transform: scale(1);
}

.filled-hover-button:hover {
    background-color: #e6007e !important;
    transform: scale(0.95);
}

.default-hover-button {
    transition: 0.3s;
    transform: scale(1);
}

.default-hover-button:hover {
    transform: scale(0.95);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,0BAA0B;AAC1B;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB;0BACsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB;0BACsB;AAC1B;;AAEA;IACI,SAAS;IACT,0DAA0D;IAC1D,8CAA8C;IAC9C,mCAAmC;IACnC,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI;iBACa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai:wght@100;200;300;400;500;600;700;800;900&display=swap');\r\n\r\n/* import font from file */\r\n@font-face {\r\n    font-family: 'KaLaTeXa';\r\n    font-style: normal;\r\n    font-weight: 100;\r\n    src: url('./utils/font/KaLaTeXa_ Font/KaLaTeXaTEXT_Regular.ttf')\r\n        format('truetype');\r\n}\r\n\r\n@font-face {\r\n    font-family: 'KaLaTeXa';\r\n    font-style: bold;\r\n    font-weight: 400;\r\n    src: url('./utils/font/KaLaTeXa_ Font/KaLaTeXaTEXT_Bold.ttf')\r\n        format('truetype');\r\n}\r\n\r\nbody {\r\n    margin: 0;\r\n    /* font-family: 'Noto Sans Thai', sans-serif !important; */\r\n    font-family: 'KaLaTeXa', sans-serif !important;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    overflow-x: hidden;\r\n}\r\n\r\ncode {\r\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n        monospace;\r\n}\r\n\r\n.filled-hover-button {\r\n    transition: 0.3s;\r\n    transform: scale(1);\r\n}\r\n\r\n.filled-hover-button:hover {\r\n    background-color: #e6007e !important;\r\n    transform: scale(0.95);\r\n}\r\n\r\n.default-hover-button {\r\n    transition: 0.3s;\r\n    transform: scale(1);\r\n}\r\n\r\n.default-hover-button:hover {\r\n    transform: scale(0.95);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
